<template>
  <div class="topbar">
    <el-row>
      <el-col :sm="4" :md="4">
        <div class="brand-logo">
          <a style="cursor:pointer;"><img src="@/assets/img/logo-white.png"></a>
        </div>
      </el-col>
      <el-col :sm="20" :md="20">
        <div class="topbar-right">
          <el-menu :default-active="activeIndex" mode="horizontal">
            <el-submenu index="1" popper-class="topbar-right-submenu-lan">
              <template slot="title">{{ currentlang }}</template>
              <el-menu-item index="1-1"><el-button type="text" size="mini" @click="setLanguage('中文')">中文</el-button></el-menu-item>
              <el-menu-item index="1-2"><el-button type="text" size="mini" @click="setLanguage('English')">English</el-button></el-menu-item>
              <el-menu-item index="1-3"><el-button type="text" size="mini" @click="setLanguage('日本語')">日本語</el-button></el-menu-item>
            </el-submenu>
            <el-submenu index="5" popper-class="topbar-right-submenu-logout">
              <template slot="title">{{ username }}</template>
              <el-menu-item index="5-1"><a href="javascript:;" @click="onLoginout">{{ $t("PageCommon.Logout") }}</a></el-menu-item>
            </el-submenu>
          </el-menu>
        </div>
      </el-col>
    </el-row>
  </div>  
</template>

<script>
export default {
  
  data () {
    return {
      currentlang: '',
      showuserminicard: false,
      langs : '',
      username : '',
      companyname : '',
      balance : 0,
      userstatuscode: '',
      logourl: false,
      defaultid: '',
      showpartnerlogo: false,
      imgurl: '',
      showmodelsetting: false,
      logodata: {},
      activeIndex: '0',
      showurl: false,
    }
  },

  mounted() {

    if(window.localStorage.getItem('localeLanguage')){
      if(window.localStorage.getItem('localeLanguage') === 'zh'){
        this.currentlang = '中文'
      }
      if(window.localStorage.getItem('localeLanguage') === 'en'){
        this.currentlang = 'English'
      }
      if(window.localStorage.getItem('localeLanguage') === 'jp'){
        this.currentlang = '日本語'
      }
    }else{
      this.currentlang = '中文'
    }
    this.langs = window.localStorage.getItem('localeLanguage') ? window.localStorage.getItem('localeLanguage') === 'en'?'中':'EN' : 'EN'
    
    let _user = JSON.parse(localStorage.getItem("user")).val
    this.username = _user.name

  },

  methods : {

    /**
     * 显示用户迷你资料卡
     */
    showUserMiniTabs: function(){
      this.getUserBalance()
    },

    /**
     * 切换语言
     */
    changeLanguage : function() {
      if (this.$i18n.locale == 'en') {
        this.$i18n.locale = 'zh';
        this.langs = 'EN';
        window.localStorage.setItem('localeLanguage', this.$i18n.locale)
        this.$store.state.lan = this.$i18n.locale
      } else {
        this.$i18n.locale = 'en';
        this.langs = '中';
        window.localStorage.setItem('localeLanguage', this.$i18n.locale)
        this.$store.state.lan = this.$i18n.locale
      }
    },

    /**
     * 设置语言
     */
    setLanguage: function(command){
      if(command === '中文'){
        this.$i18n.locale = 'zh';
        window.localStorage.setItem('localeLanguage', this.$i18n.locale)
      }
      if(command === 'English'){
        this.$i18n.locale = 'en';
        window.localStorage.setItem('localeLanguage', this.$i18n.locale)
      }
      if(command === '日本語'){
        this.$i18n.locale = 'jp';
        window.localStorage.setItem('localeLanguage', this.$i18n.locale)
      }
      this.$store.state.lan = this.$i18n.locale
      window.location.reload()
      this.currentlang = command
    },

    /**
     * 发送退出请求
     * 保留用户当前设置的语言
     */
    onLoginout: function(){
      var that = this
      let url = that.API_URL + '/v3/users/logout';
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        success: function(rex) {
          let currentlan = localStorage.getItem("localeLanguage")

          if(JSON.parse(localStorage.getItem("isremenber")).val === true){
            /**
             * 清除localstorage并重新写入密码资料
             */
            let _email = JSON.parse(localStorage.getItem("loginemail")).val
            let _passwd = JSON.parse(localStorage.getItem("loginpasswd")).val
            let _isremenber = JSON.parse(localStorage.getItem("isremenber")).val
            
            localStorage.clear()
            that.setLocalStorage( "isremenber", _isremenber )
            that.setLocalStorage( "loginemail", _email )
            that.setLocalStorage( "loginpasswd", _passwd )
          }else{
            localStorage.clear()
          }

          window.localStorage.setItem('localeLanguage', currentlan)
          that.$router.push({ path: "/Login" })
          console.log(rex)
        },
        error: function(response) {
          console.log(response)
        }
      })
    },

    tonewticket: function(){
      this.getKf5SsoToken()
    },

  }
}
</script>
